import React from 'react';
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend
} from 'recharts';
import './Charts.css';

const CostBreakdownChart = ({ data }) => {
  const chartData = [
    { name: 'Food Cost', value: parseFloat(data.foodCost) || 0, color: '#ef4444' },
    { name: 'Labor Cost', value: parseFloat(data.laborCost) || 0, color: '#f59e0b' },
    { name: 'Other Costs', value: parseFloat(data.otherCosts) || 0, color: '#8b5cf6' },
    { name: 'Net Profit', value: parseFloat(data.netProfit) || 0, color: '#10b981' }
  ];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const total = chartData.reduce((sum, item) => sum + item.value, 0);
      const percentage = ((payload[0].value / total) * 100).toFixed(1);
      
      return (
        <div className="custom-tooltip">
          <p className="tooltip-label">{payload[0].name}</p>
          <p className="tooltip-value">
            <strong>₹{payload[0].value.toLocaleString('en-IN')}</strong>
          </p>
          <p className="tooltip-sub">{percentage}% of revenue</p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="chart-container">
      <h3 className="chart-title">Cost & Profit Breakdown</h3>
      
      {/* Percentage indicators */}
      <div className="cost-indicators">
        <div className="cost-indicator">
          <span className="indicator-label">Food Cost %</span>
          <span className={`indicator-value ${parseFloat(data.foodCostPercentage) > data.targets.foodCostTarget ? 'warning' : 'success'}`}>
            {data.foodCostPercentage}%
          </span>
          <span className="indicator-target">Target: {data.targets.foodCostTarget}%</span>
        </div>
        
        <div className="cost-indicator">
          <span className="indicator-label">Labor Cost %</span>
          <span className={`indicator-value ${parseFloat(data.laborCostPercentage) > data.targets.laborCostTarget ? 'warning' : 'success'}`}>
            {data.laborCostPercentage}%
          </span>
          <span className="indicator-target">Target: {data.targets.laborCostTarget}%</span>
        </div>
        
        <div className="cost-indicator">
          <span className="indicator-label">Prime Cost %</span>
          <span className={`indicator-value ${parseFloat(data.primeCostPercentage) > data.targets.primeCostTarget ? 'warning' : 'success'}`}>
            {data.primeCostPercentage}%
          </span>
          <span className="indicator-target">Target: {data.targets.primeCostTarget}%</span>
        </div>
        
        <div className="cost-indicator">
          <span className="indicator-label">Net Profit %</span>
          <span className={`indicator-value ${parseFloat(data.netProfitMargin) >= data.targets.netProfitTarget ? 'success' : 'warning'}`}>
            {data.netProfitMargin}%
          </span>
          <span className="indicator-target">Target: {data.targets.netProfitTarget}%</span>
        </div>
      </div>

      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
            outerRadius={100}
            fill="#8884d8"
            dataKey="value"
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CostBreakdownChart;

